"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkConnector = void 0;
const provider_type_1 = require("@dcl/schemas/dist/dapps/provider-type");
const network_connector_1 = require("@web3-react/network-connector");
const configuration_1 = require("../configuration");
class NetworkConnector extends network_connector_1.NetworkConnector {
  constructor(chainId) {
    super({
      urls: configuration_1.getConfiguration()[provider_type_1.ProviderType.NETWORK].urls,
      defaultChainId: chainId
    });
  }
}
exports.NetworkConnector = NetworkConnector;